import { useState, useEffect } from "react";

function useIsMobile() {
  const getIsMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobileUserAgentRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    
    if (mobileUserAgentRegex.test(userAgent.toLowerCase())) {
      return true;
    }
    
    const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    let screenWidth = window.screen?.width;
    let viewportWidth = window.innerWidth;
    
    try {
      if (window.parent !== window) {
        screenWidth = window.parent.screen?.width || screenWidth;
      }
    } catch {
    }
    
    const referenceWidth = screenWidth || viewportWidth;
    
    const isSmallScreen = referenceWidth <= 768;

    return hasTouchScreen && isSmallScreen;
  }

  const [isMobile, setIsMobile] = useState(getIsMobile)

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile())
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return isMobile
}

export default useIsMobile
